import { useTranslation } from 'react-i18next';
import { string } from 'yup';
import clsx from 'clsx';
import { FormConfig } from '@dxb-web-ui-framework/content-composer/components/FormBuilder/types';
import { Box, Button, makeStyles } from '@dxb-web-ui-framework/design-system';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import React from 'react';
import { ECOMMBXLoader } from '../../../../../content-composer/src/components/Generic/ECOMMBXLoader/ECOMMBXLoader';
import { ValueIdentifier } from '../../types';

const useStyles = makeStyles(theme => ({
  submitButton: {
    [theme.breakpoints.down('sm')]: {
      marginTop: 'auto !important',
      marginBottom: theme.spacing(4),
    },
  },
  marginButton: {
    marginTop: theme.spacing(5),
  },
  loaderContainer: {
    width: '100%',
    marginTop: theme.spacing(4),
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      flex: 1,
      alignItems: 'center',
    },
  },
}));
const useBicManuallyConfig = (isLoading: boolean, bicQuery: Nullable<string>): FormConfig => {
  const classes = useStyles();
  const { t } = useTranslation();

  return {
    validationSchema: {
      [ValueIdentifier.BIC]: string().required(t('fundsTransferPage.Forms.GenericDrawer.Validations.Bic')),
    },
    components: [
      {
        label: t('fundsTransferPage.Forms.GenericDrawer.Bic'),
        key: ValueIdentifier.BIC,
        type: 'text',
        defaultValue: '',
        disabled: isLoading,
      },
      {
        type: 'dynamicComponent',
        key: 'dynamicComponent',
        properties: {
          component: (_: any) => (
            <Box width='100%' display='flex' flexDirection='column' flex={1}>
              {isLoading && (
                <Box className={classes.loaderContainer}>
                  <ECOMMBXLoader size='small' verticalSpacing='small' />
                </Box>
              )}
              <Button
                fullWidth
                color='primary'
                disabled={isLoading}
                size='large'
                variant='contained'
                classes={{ root: clsx(classes.marginButton, classes.submitButton) }}
                title={t('fundsTransferPage.Forms.GenericDrawer.ApplyBtn')}
                type='submit'>
                {t('fundsTransferPage.Forms.GenericDrawer.ApplyBtn')}
              </Button>
            </Box>
          ),
        },
      },
    ],
    preloadedData: {
      [ValueIdentifier.BIC]: bicQuery ?? '',
    },
    preloadedDataValidationOptions: { shouldValidate: false, shouldDirty: true },
  };
};

export { useBicManuallyConfig };
